/*
 * /game-call-trainer — страница тренажёра манков.
 *
 * Эталон (MP3 из public/audio/game-call-trainer) декодируется в
 * OfflineAudioContext — без жеста и без живого контекста; живой контекст
 * нужен только для прослушивания и микрофона и рождается на нажатии.
 * Микрофон — MicManager.startRaw без шумодава и автогромкости: они режут
 * свист и меняют спектр, а именно спектр и сравнивается. Захват — общий
 * ворклет pcm-capture (запасной путь — ScriptProcessor).
 *
 * Разбор и оценка — GameCallEngine (engine.js), слова подсказок — из
 * перевода (cfg.i18n), числа — по языку страницы.
 */
(function () {
    'use strict';

    var cfgEl = document.getElementById('gcCfg');
    var E = window.GameCallEngine;
    if (!cfgEl || !E) return;
    var CFG = JSON.parse(cfgEl.textContent || '{}');
    var SLUG = CFG.slug;
    var UI = CFG.ui || {};
    var I18N = CFG.i18n || {};
    var MAX_OWN_S = 20;

    function $(id) { return document.getElementById(id); }
    var el = {
        root: $('gc'), sel: $('gcSpeciesSel'), species: $('gcSpecies'), varsPanel: $('gcVarsPanel'),
        refName: $('gcRefName'), refMeta: $('gcRefMeta'), refSpec: $('gcRefSpec'), refHead: $('gcRefHead'), refPlay: $('gcRefPlay'),
        rec: $('gcRec'), recLbl: $('gcRecLbl'), level: $('gcLevel'), status: $('gcStatus'), srWarn: $('gcSrWarn'), trySpec: $('gcTrySpec'),
        result: $('gcResult'), score: $('gcScore'), verdict: $('gcVerdict'), axP: $('gcAxPitch'), axPL: $('gcAxPitchL'),
        axR: $('gcAxRhythm'), axT: $('gcAxTimbre'), hints: $('gcHints'), chart: $('gcChart'), playTry: $('gcPlayTry'),
        again: $('gcAgain'), history: $('gcHistory'), ownDrop: $('gcOwnDrop'), ownStatus: $('gcOwnStatus'), ownSub: $('gcOwnChipSub'),
    };

    var species = {};
    (CFG.species || []).forEach(function (s) { species[s.id] = s; });
    var recordings = CFG.recordings || {};

    var st = {
        sp: null, ref: null, refs: {}, ctx: null, player: null, rec: null, last: null, history: {}, mic: null, busy: false,
    };

    // ── мелочи ─────────────────────────────────────────────────────────────
    function loc() { try { return typeof window.__intlLocale === 'function' ? window.__intlLocale() : undefined; } catch (_) { return undefined; } }
    function num(v, d) {
        try { return new Intl.NumberFormat(loc(), { maximumFractionDigits: d == null ? 1 : d, minimumFractionDigits: 0 }).format(v); } catch (_) { return String(Math.round(v)); }
    }
    function fmt(tpl, p) {
        var s = String(tpl || '');
        Object.keys(p || {}).sort(function (a, b) { return b.length - a.length; }).forEach(function (k) { s = s.split(':' + k).join(String(p[k])); });
        return s;
    }
    // Указатель из цикла кадров — через общий примитив, с местной страховкой
    // на случай старого ядра у страницы из кэша (PlayheadWritesGoThroughThePrimitiveTest).
    function pxWrite(e, p, v, u) { if (window.__perPixel) return window.__perPixel(e, p, v, u); e.style[p] = v + (u || '%'); }
    function stage(n) { try { if (typeof window.__stage === 'function') window.__stage(n); } catch (_) {} }
    function ae(name, data) { try { if (typeof window.__ae === 'function') window.__ae(name, Object.assign({ slug: SLUG }, data || {})); } catch (_) {} }
    function say(msg) { el.status.textContent = msg; }
    function fail(err, label, phrase) {
        try {
            if (typeof window.__handleError === 'function') window.__handleError(err, label, { say: phrase });
            else if (window.__toast) window.__toast(phrase, 'error');
        } catch (_) {}
    }
    function liveCtx() {
        var make = function () { return new (window.AudioContext || window.webkitAudioContext)({ latencyHint: 'interactive' }); };
        if (typeof window.__liveAudioCtxReady === 'function') {
            return window.__liveAudioCtxReady(st.ctx, make).then(function (c) { st.ctx = c; return c; });
        }
        if (!st.ctx) st.ctx = make();
        return (st.ctx.state === 'running' ? Promise.resolve() : st.ctx.resume()).then(function () { return st.ctx; });
    }

    // ── выбор вида и записи ────────────────────────────────────────────────
    function selectSpecies(id, userAction) {
        if (!species[id]) return;
        st.sp = id;
        el.species.querySelectorAll('.gc-sp').forEach(function (b) {
            var on = b.getAttribute('data-sp') === id;
            b.classList.toggle('on', on);
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        document.querySelectorAll('.gc-vars').forEach(function (v) { v.hidden = v.getAttribute('data-for') !== id; });
        document.querySelectorAll('.gc-tip').forEach(function (p) { p.hidden = p.getAttribute('data-for') !== id; });
        el.varsPanel.hidden = species[id].refs.length < 2;
        if (userAction && el.sel && id !== 'own') {
            el.sel.value = id;
            try { el.sel.dispatchEvent(new Event('change', { bubbles: true })); } catch (_) {}
        }
        selectRef(species[id].refs[0]);
    }

    function selectRef(rid) {
        st.ref = rid;
        var sp = species[st.sp];
        document.querySelectorAll('.gc-vars[data-for="' + st.sp + '"] .tc-seg-b').forEach(function (b) {
            var on = b.getAttribute('data-ref') === rid;
            b.classList.toggle('on', on);
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        document.querySelectorAll('.gc-attr').forEach(function (p) { p.hidden = p.getAttribute('data-ref') !== rid; });
        var nameEl = el.species.querySelector('.gc-sp[data-sp="' + st.sp + '"]');
        if (nameEl) {
            var b = nameEl.querySelector('b'), s = nameEl.querySelector('span');
            el.refName.textContent = (b ? b.textContent : '') + (s && s.textContent ? ' — ' + s.textContent : '');
        }
        var rec = recordings[rid] || {};
        el.refMeta.textContent = fmt(UI.refMeta, { dur: num(rec.duration || 0, 1), lo: num(sp.band[0], 0), hi: num(sp.band[1], 0) });
        stopPlayer();
        el.result.hidden = true;
        clearCanvas(el.trySpec);
        renderHistory();
        el.root.removeAttribute('data-ref-ready');
        loadRef(rid).then(function (r) {
            if (st.ref !== rid || !r) return;
            drawSpec(el.refSpec, r.buffer, sp.band);
            checkCaptureRate();
            el.root.setAttribute('data-ref-ready', rid);
        });
    }

    function loadRef(rid) {
        if (st.refs[rid]) return Promise.resolve(st.refs[rid]);
        if (rid === 'own') return Promise.resolve(null);
        var rec = recordings[rid];
        if (!rec) return Promise.resolve(null);
        el.refMeta.textContent = UI.loading;
        var sp = species[st.sp];
        return fetch(CFG.audioBase + rec.file, { credentials: 'same-origin' })
            .then(function (r) { if (!r.ok) throw new Error('ref http ' + r.status); return r.arrayBuffer(); })
            .then(function (ab) {
                var oc = new (window.OfflineAudioContext || window.webkitOfflineAudioContext)(1, 1, 48000);
                return new Promise(function (res, rej) { oc.decodeAudioData(ab, res, rej); });
            })
            .then(function (buf) {
                var a = E.analyze(buf.getChannelData(0), buf.sampleRate, { band: sp.band, splitDb: sp.split });
                st.refs[rid] = { buffer: buf, analysis: a, sp: sp.id };
                el.refMeta.textContent = fmt(UI.refMeta, { dur: num(rec.duration, 1), lo: num(sp.band[0], 0), hi: num(sp.band[1], 0) });
                stage('ref_loaded');
                return st.refs[rid];
            })
            .catch(function (e) {
                el.refMeta.textContent = '';
                fail(e, 'gct_ref_load', UI.refFailed);
                return null;
            });
    }

    // ── картинки ───────────────────────────────────────────────────────────
    function clearCanvas(c) {
        var g = c.getContext('2d');
        g.clearRect(0, 0, c.width, c.height);
    }
    function sizeCanvas(c) {
        var dpr = Math.min(2, window.devicePixelRatio || 1);
        var w = Math.max(280, Math.round((c.clientWidth || 600) * dpr)), h = Math.round((c.clientHeight || 150) * dpr);
        if (c.width !== w) c.width = w;
        if (c.height !== h) c.height = h;
        return { w: w, h: h, dpr: dpr };
    }
    function drawSpec(canvas, buffer, band) {
        if (!window.SpectrogramRenderer || !buffer) return;
        var s = sizeCanvas(canvas);
        var nyq = buffer.sampleRate / 2;
        // Рендерер не нормирует модуль спектра на окно: синус полной громкости
        // в окне 2048 даёт ≈ +54 дБ. Потолок — от пика самой записи (тихая
        // попытка с телефона и громкий эталон видны одинаково), диапазон 72 дБ.
        var d = buffer.getChannelData(0), pk = 0;
        for (var i = 0; i < d.length; i += 4) { var v = d[i] < 0 ? -d[i] : d[i]; if (v > pk) pk = v; }
        var ceil = 20 * Math.log10(Math.max(1e-4, pk) * 2048 / 4) + 2;
        try {
            window.SpectrogramRenderer.render(buffer, canvas, {
                width: s.w, height: s.h, fftSize: 2048, scale: 'linear',
                fmin: Math.max(0, band[0] * 0.5), fmax: Math.min(nyq, band[1] * 1.12), dbFloor: ceil - 72, dbCeil: ceil,
            });
        } catch (e) { fail(e, 'gct_spectrogram'); }
    }

    // ── прослушивание ─────────────────────────────────────────────────────
    function stopPlayer() {
        if (st.player) {
            try { st.player.src.onended = null; st.player.src.stop(); } catch (_) {}
            st.player = null;
        }
        el.refHead.hidden = true;
        el.refPlay.textContent = '▶ ' + UI.play;
    }
    function playBuffer(buffer, onTick, onEnd) {
        return liveCtx().then(function (ctx) {
            var src = ctx.createBufferSource();
            src.buffer = buffer;
            src.connect(ctx.destination);
            var t0 = ctx.currentTime + 0.02;
            src.start(t0);
            var p = { src: src, t0: t0, dur: buffer.duration };
            src.onended = function () { if (onEnd) onEnd(); };
            if (onTick) {
                var tick = function () {
                    if (st.player !== p) return;
                    var f = (ctx.currentTime - p.t0) / p.dur;
                    if (f >= 0 && f <= 1) onTick(f);
                    if (f < 1) requestAnimationFrame(tick);
                };
                requestAnimationFrame(tick);
            }
            return p;
        });
    }
    function playRef() {
        if (st.player) { stopPlayer(); return; }
        var r = st.refs[st.ref];
        if (!r) return;
        playBuffer(r.buffer, function (f) {
            el.refHead.hidden = false;
            pxWrite(el.refHead, 'left', f * 100);
        }, function () { st.player = null; stopPlayer(); }).then(function (p) {
            st.player = p;
            el.refPlay.textContent = '■ ' + UI.stop;
            // Послушал эталон — следующим нажмёт «Позвать»: модуль записи готовим заранее.
            if (st.ctx) workletReady(st.ctx).catch(function () {});
        }).catch(function (e) { fail(e, 'gct_play'); });
    }

    // ── частота дискретизации микрофона ───────────────────────────────────
    function captureRate(stream, ctx) {
        var sr = ctx ? ctx.sampleRate : 48000;
        try {
            var s = stream.getAudioTracks()[0].getSettings();
            if (s && s.sampleRate) sr = Math.min(sr, s.sampleRate);
        } catch (_) {}
        return sr;
    }
    function checkCaptureRate() {
        var r = st.refs[st.ref];
        if (!r || !st.lastCaptureSr) { el.srWarn.hidden = true; return; }
        var need = r.analysis.topHz;
        if (need > 0 && st.lastCaptureSr / 2 * 0.92 < need) {
            el.srWarn.textContent = fmt(UI.srWarn, { max: num(Math.round(st.lastCaptureSr / 2), 0), need: num(Math.round(need), 0) });
            el.srWarn.hidden = false;
        } else el.srWarn.hidden = true;
    }

    // ── запись попытки ─────────────────────────────────────────────────────
    function setRecUi(mode) {
        el.rec.classList.toggle('live', mode === 'rec' || mode === 'wait');
        el.recLbl.textContent = mode === 'rec' || mode === 'wait' ? UI.recStop : UI.record;
        el.rec.disabled = mode === 'busy';
    }
    /* Модуль ворклета грузится ПАРАЛЛЕЛЬНО с открытием микрофона: иначе первые
       ~0,5–1,5 с после нажатия (замер стендом) звук уже идёт, а записи ещё нет,
       и нетерпеливый первый свист обрезается. Один промис на живой контекст. */
    function workletReady(ctx) {
        var urls = (CFG.workletUrls || []).filter(Boolean);
        if (!(ctx.audioWorklet && window.AudioWorkletLoader && urls.length)) return Promise.reject(new Error('no worklet'));
        if (st.workletCtx !== ctx) {
            st.workletCtx = ctx;
            st.workletP = window.AudioWorkletLoader.load(ctx, urls, { slug: SLUG });
        }
        return st.workletP;
    }
    function attachTap(ctx, srcNode, onBatch) {
        var viaWorklet = ctx.audioWorklet && window.AudioWorkletLoader
            ? workletReady(ctx).then(function () {
                var node = new AudioWorkletNode(ctx, 'pcm-capture');
                node.port.onmessage = function (ev) {
                    var d = ev.data;
                    if (d && d.type === 'pcm' && d.channels && d.channels[0]) onBatch(d.channels[0]);
                };
                srcNode.connect(node);
                return node;
            })
            : Promise.reject(new Error('no worklet'));
        return viaWorklet.catch(function () {
            if (!ctx.createScriptProcessor) throw new Error('no capture');
            var proc = ctx.createScriptProcessor(4096, 1, 1);
            proc.onaudioprocess = function (e) { onBatch(new Float32Array(e.inputBuffer.getChannelData(0))); };
            srcNode.connect(proc);
            return proc;
        });
    }

    function startRecording() {
        if (st.rec || st.busy) return;
        var r = st.refs[st.ref];
        // Нажали раньше, чем докачался эталон, — дождаться его, а не молчать.
        if (!r) { loadRef(st.ref).then(function (x) { if (x) startRecording(); }); return; }
        stopPlayer();
        st.busy = true;
        setRecUi('busy');
        say(UI.opening);
        var ctx;
        liveCtx().then(function (c) {
            ctx = c;
            workletReady(ctx).catch(function () {});
            if (!st.mic) st.mic = new window.MicManager({ locale: window.__LOCALE, slug: SLUG });
            return st.mic.startRaw({ audio: { channelCount: 1, echoCancellation: false, noiseSuppression: false, autoGainControl: false } });
        }).then(function (stream) {
            st.lastCaptureSr = captureRate(stream, ctx);
            checkCaptureRate();
            var src = ctx.createMediaStreamSource(stream);
            var refDur = Math.max(0.6, r.analysis.durationS || 2);
            var rec = {
                stream: stream, src: src, node: null, mute: null, chunks: [], n: 0, sr: ctx.sampleRate,
                noise: [], noiseDb: null, soundAt: -1, lastLoud: -1, t: 0, refDur: refDur, done: false,
            };
            st.rec = rec;
            stage('mic_open');
            return attachTap(ctx, src, function (chunk) { onChunk(rec, chunk); }).then(function (node) {
                rec.node = node;
                var mute = ctx.createGain();
                mute.gain.value = 0;
                try { node.connect(mute); mute.connect(ctx.destination); } catch (_) {}
                rec.mute = mute;
                stream.getTracks().forEach(function (tr) { tr.onended = function () { if (st.rec === rec) stopRecording('ended'); }; });
                st.busy = false;
                setRecUi('wait');
                say(UI.wait);
            });
        }).catch(function (e) {
            st.busy = false;
            setRecUi('idle');
            cleanupRec();
            // Отказ микрофона MicManager объяснил сам (окно с инструкцией); здесь — строка статуса.
            say(I18N.mic_failed || '');
            fail(e, 'gct_mic');
        });
    }

    function onChunk(rec, chunk) {
        if (st.rec !== rec || rec.done) return;
        rec.chunks.push(chunk);
        rec.n += chunk.length;
        rec.t = rec.n / rec.sr;
        var sum = 0, peak = 0;
        for (var i = 0; i < chunk.length; i++) { var v = chunk[i]; sum += v * v; if (v > peak) peak = v; else if (-v > peak) peak = -v; }
        var db = 10 * Math.log10(sum / chunk.length + 1e-12);
        el.level.style.width = Math.min(100, Math.round(Math.sqrt(peak) * 115)) + '%';
        // Первые 0,4 с — фон комнаты; звук — на 12 дБ громче фона и не тише −55 dBFS.
        if (rec.t <= 0.4) { rec.noise.push(db); return; }
        if (rec.noiseDb == null) { var a = rec.noise.slice().sort(function (x, y) { return x - y; }); rec.noiseDb = a.length ? a[a.length >> 1] : -70; }
        var loud = db > Math.max(rec.noiseDb + 12, -55);
        if (loud) {
            if (rec.soundAt < 0) { rec.soundAt = rec.t; say(UI.rec); }
            rec.lastLoud = rec.t;
        }
        var quietFor = Math.max(0.9, rec.refDur * 0.45);
        if (rec.soundAt >= 0 && rec.t - rec.lastLoud > quietFor && rec.t - rec.soundAt > 0.25) stopRecording('silence');
        else if (rec.soundAt >= 0 && rec.t - rec.soundAt > rec.refDur * 2.4 + 1.5) stopRecording('long');
        else if (rec.soundAt < 0 && rec.t > 8) stopRecording('nothing');
        else if (rec.t > 16) stopRecording('max');
    }

    function cleanupRec() {
        var rec = st.rec;
        st.rec = null;
        if (rec) {
            rec.done = true;
            try { if (rec.node && rec.node.port) rec.node.port.postMessage({ cmd: 'stop' }); } catch (_) {}
            try { rec.src.disconnect(); } catch (_) {}
            try { if (rec.node) rec.node.disconnect(); } catch (_) {}
            try { if (rec.mute) rec.mute.disconnect(); } catch (_) {}
        }
        try { if (st.mic) st.mic.stop(); } catch (_) {}
        el.level.style.width = '0%';
        return rec;
    }

    function stopRecording(why) {
        var rec = cleanupRec();
        if (!rec) return;
        ae('feature_use', { f: 'gct_stop', why: why, dur: Math.round(rec.t * 10) / 10 });
        setRecUi('busy');
        say(UI.busy);
        var x = new Float32Array(rec.n), o = 0;
        rec.chunks.forEach(function (c) { x.set(c, o); o += c.length; });
        // Разбор — в следующем кадре, чтобы статус успел нарисоваться.
        setTimeout(function () { score(x, rec.sr); }, 30);
    }

    function score(x, sr) {
        var r = st.refs[st.ref], sp = species[st.sp];
        try {
            var T = E.analyzeAttempt(r.analysis, x, sr);
            if (st.lastCaptureSr && st.lastCaptureSr < sr) T.sr = st.lastCaptureSr;
            var res = E.compare(r.analysis, T, sp.kind);
            T.sr = sr;
            st.last = { x: x, sr: sr, T: T, res: res };
            showAttempt(x, sr, sp);
            render(res, r.analysis, T, sp);
        } catch (e) {
            fail(e, 'gct_score');
        }
        setRecUi('idle');
    }

    function showAttempt(x, sr, sp) {
        var ctxLike = st.ctx;
        try {
            var buf = ctxLike ? ctxLike.createBuffer(1, x.length, sr) : new AudioBuffer({ length: x.length, sampleRate: sr, numberOfChannels: 1 });
            buf.copyToChannel(x, 0);
            st.last.buffer = buf;
            drawSpec(el.trySpec, buf, sp.band);
        } catch (e) { fail(e, 'gct_attempt_view'); }
    }

    // ── результат ─────────────────────────────────────────────────────────
    function hintText(h) {
        var tpl = (I18N.hint || {})[h.code];
        if (!tpl) return null;
        return fmt(tpl, {
            ref: h.ref, got: h.got, pct: h.pct, n: h.n,
            s: h.s != null ? num(h.s, 2) : '', st: h.st != null ? num(h.st, 1) : '',
            lo: h.lo != null ? num(h.lo, 0) : '', hi: h.hi != null ? num(h.hi, 0) : '',
        });
    }
    function tile(node, v) {
        var vEl = node.querySelector('.tc-stat-v');
        vEl.textContent = v == null ? '—' : String(v);
        node.classList.remove('good', 'warn', 'bad');
        if (v != null) node.classList.add(v >= 75 ? 'good' : v >= 50 ? 'warn' : 'bad');
    }
    function render(res, R, T, sp) {
        if (!res.ok) {
            var reasons = I18N.reason || {};
            var p = { lo: num(sp.band[0], 0), hi: num(sp.band[1], 0) };
            if (res.reason === 'band_cut') { p.max = num(Math.round(res.cut.sr / 2), 0); p.need = num(res.cut.needHz, 0); }
            if (res.reason === 'off_band') p.hz = num(Math.round(res.offBand.hz / 10) * 10, 0);
            say(fmt(reasons[res.reason] || '', p));
            el.result.hidden = true;
            ae('feature_use', { f: 'gct_unscored', reason: res.reason, sp: sp.id });
            return;
        }
        say(UI.idle);
        el.result.hidden = false;
        el.score.textContent = res.score;
        el.verdict.textContent = res.score >= 85 ? UI.great : res.score >= 70 ? UI.good : res.score >= 50 ? UI.fair : UI.poor;
        el.axPL.textContent = sp.kind === 'noisy' ? UI.pitchNoisy : UI.pitch;
        tile(el.axP, res.pitch ? res.pitch.score : null);
        tile(el.axR, res.rhythm ? res.rhythm.score : null);
        tile(el.axT, res.timbre ? res.timbre.score : null);
        el.hints.textContent = '';
        var shown = 0, seen = {};
        (res.hints || []).forEach(function (h) {
            if (shown >= 3 || seen[h.code]) return;
            var txt = hintText(h);
            if (!txt) return;
            seen[h.code] = 1;
            var li = document.createElement('li');
            li.textContent = txt;
            el.hints.appendChild(li);
            shown++;
        });
        if (!shown) {
            var ok = document.createElement('li');
            ok.className = 'ok';
            ok.textContent = '✓ ' + UI.hintsNone;
            el.hints.appendChild(ok);
        }
        drawChart(el.chart, R, T, res, sp);
        var hist = st.history[st.ref] || (st.history[st.ref] = []);
        hist.push(res.score);
        if (hist.length > 12) hist.shift();
        renderHistory();
        if (typeof window.__announce === 'function') window.__announce(res.score + ' — ' + el.verdict.textContent);
        stage('attempt_scored');
        try { if (typeof window.__aeToolComplete === 'function') window.__aeToolComplete({ sp: sp.id, score: res.score }); } catch (_) {}
        ae('feature_use', { f: 'gct_score', sp: sp.id, ref: st.ref, s: res.score, p: res.pitch && res.pitch.score, r: res.rhythm && res.rhythm.score, t: res.timbre && res.timbre.score });
    }

    function renderHistory() {
        el.history.textContent = '';
        var hist = st.history[st.ref] || [];
        var best = hist.length ? Math.max.apply(null, hist) : -1;
        hist.forEach(function (s, i) {
            var c = document.createElement('span');
            c.textContent = fmt(I18N.attempt_n || ':n', { n: i + 1 }) + ': ' + s;
            if (s === best && hist.length > 1) c.className = 'best';
            el.history.appendChild(c);
        });
    }

    /* График: время эталона по горизонтали. Звуки попытки ложатся на
       сопоставленные звуки эталона — так видно и тон внутри звука, и сдвиг
       ритма. Тон (или центроид у шумных) — логарифмически по полосе вида. */
    function drawChart(canvas, R, T, res, sp) {
        var s = sizeCanvas(canvas), g = canvas.getContext('2d');
        var W = s.w, H = s.h, pad = Math.round(6 * s.dpr), axisW = Math.round(46 * s.dpr);
        g.clearRect(0, 0, W, H);
        var cs = getComputedStyle(canvas);
        var accent = cs.getPropertyValue('--lg-accent').trim() || '#7aa7ff';
        var textC = cs.getPropertyValue('--lg-text-3').trim() || '#8a93a8';
        var t0 = R.notes.length ? R.notes[0].s : 0, t1 = R.notes.length ? R.notes[R.notes.length - 1].e : 1;
        var span = Math.max(1, t1 - t0);
        var lo = sp.band[0], hi = sp.band[1];
        var ly = function (hz) { var v = Math.log(hz / lo) / Math.log(hi / lo); return H - pad - Math.max(0, Math.min(1, v)) * (H - pad * 2); };
        var lx = function (fr) { return axisW + (fr - t0) / span * (W - axisW - pad); };
        g.font = Math.round(11 * s.dpr) + 'px system-ui, sans-serif';
        g.fillStyle = textC;
        g.textBaseline = 'middle';
        [lo, Math.sqrt(lo * hi), hi].forEach(function (hz) {
            g.fillText(num(Math.round(hz / 10) * 10, 0), 2, ly(hz));
            g.fillRect(axisW - 4, ly(hz), W - axisW, 1 * s.dpr * 0.5);
        });
        var val = function (A, q) { return sp.kind === 'noisy' ? A.centroid[q] : (A.voiced[q] ? A.f0[q] : 0); };
        // эталон: полосы звуков и контур
        R.notes.forEach(function (n) {
            g.fillStyle = 'rgba(122,167,255,0.10)';
            g.fillRect(lx(n.s), pad, Math.max(1, lx(n.e) - lx(n.s)), H - pad * 2);
            g.strokeStyle = accent; g.lineWidth = 2.2 * s.dpr; g.beginPath();
            var started = false;
            for (var q = n.s; q < n.e; q++) {
                var v = val(R, q);
                if (v <= 0) { started = false; continue; }
                if (!started) { g.moveTo(lx(q), ly(v)); started = true; } else g.lineTo(lx(q), ly(v));
            }
            g.stroke();
        });
        // попытка: каждый сопоставленный звук — во времени своего звука эталона
        g.strokeStyle = '#f59e0b'; g.lineWidth = 2 * s.dpr;
        ((res.rhythm && res.rhythm.pairs) || []).forEach(function (pq) {
            var rn = R.notes[pq[0]], tn = T.notes[pq[1]];
            g.beginPath();
            var started = false;
            for (var q = tn.s; q < tn.e; q++) {
                var v = val(T, q);
                if (v <= 0) { started = false; continue; }
                var fr = rn.s + (q - tn.s + 0.5) / (tn.e - tn.s) * (rn.e - rn.s);
                if (!started) { g.moveTo(lx(fr), ly(v)); started = true; } else g.lineTo(lx(fr), ly(v));
            }
            g.stroke();
        });
        // подписи
        g.textBaseline = 'top';
        g.fillStyle = accent; g.fillText('— ' + UI.legendRef, axisW + 4, pad);
        g.fillStyle = '#f59e0b'; g.fillText('— ' + UI.legendTry, axisW + 4 + g.measureText('— ' + UI.legendRef + '   ').width, pad);
    }

    function playTry() {
        if (!st.last || !st.last.buffer) return;
        stopPlayer();
        playBuffer(st.last.buffer, null, function () { st.player = null; }).then(function (p) { st.player = p; }).catch(function (e) { fail(e, 'gct_play_try'); });
    }

    // ── свой эталон ────────────────────────────────────────────────────────
    function decodeFile(file) {
        var oc = new (window.OfflineAudioContext || window.webkitOfflineAudioContext)(1, 1, 48000);
        if (window.AudioDecoderRobust && typeof window.AudioDecoderRobust.robust === 'function') {
            return window.AudioDecoderRobust.robust(file, oc, { slug: SLUG }).then(function (r) { return r && r.buffer ? r.buffer : r; });
        }
        return file.arrayBuffer().then(function (ab) { return new Promise(function (res, rej) { oc.decodeAudioData(ab, res, rej); }); });
    }
    function onOwnFile(file) {
        if (!file) return;
        el.ownStatus.textContent = UI.loading;
        decodeFile(file).then(function (buf) {
            if (!buf || !buf.length) throw new Error('empty decode');
            var sr = buf.sampleRate, n = Math.min(buf.length, Math.round(MAX_OWN_S * sr));
            var x = new Float32Array(n);
            for (var ch = 0; ch < buf.numberOfChannels; ch++) {
                var d = buf.getChannelData(ch);
                for (var i = 0; i < n; i++) x[i] += d[i] / buf.numberOfChannels;
            }
            var prof = E.guessProfile(x, sr);
            if (!prof) { el.ownStatus.textContent = UI.ownFailed; return; }
            var mono = new AudioBuffer({ length: n, sampleRate: sr, numberOfChannels: 1 });
            mono.copyToChannel(x, 0);
            species.own = { id: 'own', band: prof.band, kind: prof.kind, split: 8, refs: ['own'], name: I18N.ref_custom };
            recordings.own = { file: '', duration: Math.round(n / sr * 10) / 10 };
            st.refs.own = { buffer: mono, analysis: E.analyze(x, sr, { band: prof.band, splitDb: 8 }), sp: 'own' };
            delete st.history.own;
            var chip = el.species.querySelector('.gc-sp[data-sp="own"]');
            if (chip) chip.hidden = false;
            if (el.ownSub) el.ownSub.textContent = num(prof.band[0], 0) + '–' + num(prof.band[1], 0) + ' Hz';
            el.ownStatus.textContent = fmt(UI.ownReady, { lo: num(prof.band[0], 0), hi: num(prof.band[1], 0) }) + (buf.length > n ? ' ' + (I18N.too_long_file || '') : '');
            selectSpecies('own', true);
            ae('feature_use', { f: 'gct_own_ref', kind: prof.kind, dur: Math.round(n / sr) });
        }).catch(function (e) {
            el.ownStatus.textContent = I18N.decode_failed || '';
            fail(e, 'gct_own_decode', I18N.decode_failed);
        });
    }

    // ── провода ────────────────────────────────────────────────────────────
    el.species.addEventListener('click', function (e) {
        var b = e.target.closest('.gc-sp');
        if (b && !st.rec) selectSpecies(b.getAttribute('data-sp'), true);
    });
    document.querySelectorAll('.gc-vars').forEach(function (v) {
        v.addEventListener('click', function (e) {
            var b = e.target.closest('.tc-seg-b');
            if (b && !st.rec) selectRef(b.getAttribute('data-ref'));
        });
    });
    el.refPlay.addEventListener('click', playRef);
    el.rec.addEventListener('click', function () { if (st.rec) stopRecording('manual'); else startRecording(); });
    el.playTry.addEventListener('click', playTry);
    el.again.addEventListener('click', function () { startRecording(); });
    if (el.ownDrop) {
        if (typeof window.__bindUploaderFile === 'function') window.__bindUploaderFile(el.ownDrop, function (f) { onOwnFile(f && f.file ? f.file : f); });
        else el.ownDrop.addEventListener('tool-uploader:file', function (e) { onOwnFile(e.detail && e.detail.file); });
    }
    window.addEventListener('pagehide', function () { if (st.rec) cleanupRec(); stopPlayer(); });
    // Шов для стенда (tests/playwright/game-call-trainer-scores-the-call.mjs): последний разбор.
    window.__gameCallTrainer = { state: st };

    // Старт: вид из ссылки (?call=), иначе запомненный, иначе первый.
    var first = (CFG.species && CFG.species[0] && CFG.species[0].id) || null;
    var fromUrl = null;
    try { fromUrl = new URLSearchParams(location.search).get('call'); } catch (_) {}
    try { if (window.__toolSettings && el.sel) window.__toolSettings.bind(SLUG, el.sel, 'species', first); } catch (_) {}
    var initial = species[fromUrl] ? fromUrl : (el.sel && species[el.sel.value] ? el.sel.value : first);
    selectSpecies(initial, false);

    // Нажатия до скрипта (первый экран — в разметке): сначала вид, потом действие.
    try {
        if (window.__earlyAction) {
            window.__earlyAction.claim('game-call-trainer-species', function (id) { if (species[id]) selectSpecies(id, true); });
            window.__earlyAction.claim('game-call-trainer', function (act) {
                var go = function () { if (act === 'play') playRef(); else if (act === 'record') startRecording(); };
                loadRef(st.ref).then(function () { go(); });
            });
        }
    } catch (_) {}
})();
